"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _utils = require("@package/utils");

var _storybook = require("@pikassa/storybook");

var _dicts = require("@package/dicts");

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Amount(_ref) {
  var finalAmount = _ref.finalAmount,
      amount = _ref.amount,
      currency = _ref.currency;

  try {
    var finAmount = _utils.numbers.price(finalAmount);

    var defAmount = _utils.numbers.price(amount);

    return /*#__PURE__*/_react["default"].createElement("span", {
      "data-locator": "invoice.amount",
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'body',
      "data-locator": "invoice.amount.final"
    }, finAmount, " ", _dicts.CURRENCY_SYMBOLS[currency])), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment',
      "data-locator": "invoice.amount.default"
    }, defAmount, " ", _dicts.CURRENCY_SYMBOLS[currency])));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Amount;
exports["default"] = _default;